import type { DialogProps } from '@radix-ui/react-dialog';
import { CustomDialog } from '@ui/uikit/components/common/Dialog';

import { GetTicketsForm } from './GetTicketsForm';

type Props = DialogProps & {
  closeModal: () => void;
};

export const GetTicketsModal = ({ closeModal, ...props }: Props) => {
  const onSubmitHandler = () => {
    closeModal();
  };

  return (
    <CustomDialog {...props} title="Get Tickets" titleIsLeftAligned size="sm">
      <GetTicketsForm onSubmit={onSubmitHandler} />
    </CustomDialog>
  );
};
